import React, { useState, useEffect, useRef } from 'react';
import { LANGS, getLang, setLang } from '../utils/translations';
import './LangSwitch.css';

/**
 * 语言切换悬浮按钮：右下角地球图标，点击展开 7 语言列表。
 * 选择后持久化（localStorage），页面即时切换。
 */
const LangSwitch = () => {
  const [open, setOpen] = useState(false);
  const [lang, setLangState] = useState(getLang());
  const ref = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const pick = (code) => {
    setLang(code);
    setLangState(code);
    setOpen(false);
  };

  return (
    <div className="lang-switch" ref={ref}>
      {open && (
        <div className="lang-menu">
          {LANGS.map((l) => (
            <button
              key={l.code}
              className={`lang-item ${l.code === lang ? 'lang-item-on' : ''}`}
              onClick={() => pick(l.code)}
            >
              {l.name}
              {l.code === lang && <span className="lang-check">✓</span>}
            </button>
          ))}
        </div>
      )}
      <button className="lang-fab" onClick={() => setOpen(!open)} aria-label="Language">
        🌐
      </button>
    </div>
  );
};

export default LangSwitch;
